import { mpedStore } from '@/views/mped/services/mped-store';
import { api } from '@/service/http';
import { checkErrorResponse, errorHandler } from '@/components/utils/ai-data-source-generator';
import { dxUiNotify } from '@/utils/dx-helper';
import { showLoadPanel, hideLoadPanel } from '@/components/utils/ai-global-load-panel'
import { getCookie } from '@/utils/cookies';

export const appName = 'mped';
export const baseUrl = 'infoenergo';

function createErrorResponse(error, uuid) {
  return {
    result: false,
    error: error.message || error.error || error,
    uuid,
  };
}

function getApiRoute(method, url, fullUrl) {
  return `${fullUrl || url && `${appName}.${url}`}/${method}`;
}

export const getData = async ({ url, uuid, args, dictionary , fullUrl, fullResponse, loadPanel, throwError}) => {
  if (dictionary && mpedStore.dictionary[dictionary])
    return mpedStore.dictionary[dictionary];

  try {
    if (loadPanel)
      showLoadPanel();

    const result = await api(getApiRoute('get', url, fullUrl), {...args, appId: getCookie('app')});
    checkErrorResponse(result);
    if (dictionary)
      mpedStore.dictionary[dictionary] = result.data;

    return (fullResponse || !result.data) && result || result?.data;
  } catch (error) {
    if (!error.uuid) error.uuid = uuid;
    const errorText = errorHandler(error);
    if (throwError)
      throw new Error(errorText);
    return createErrorResponse(errorText, uuid)
  } finally {
    if (loadPanel)
      hideLoadPanel();
  }
};

export const postData = async ({ url, uuid, args, fullUrl, throwError, successNotify, successText, loadPanel }) => {
  try {
    if (loadPanel)
      showLoadPanel();
    const result = await api(getApiRoute('set', url, fullUrl), args, 300000);
    checkErrorResponse(result);
    if (successNotify || successText) {
      const text = successText || 'Данные успешно сохранены';
      dxUiNotify(text, 'success', text.length * 25);
    }

    return result.data || result;
  } catch (error) {
    if (!error.uuid) error.uuid = uuid;
    const errorText = errorHandler(error);
    if (throwError)
      throw new Error(errorText);
    return createErrorResponse(errorText, uuid)
  } finally {
    if (loadPanel)
      hideLoadPanel();
  }
};

export const setUserData = (key, data) => {
  mpedStore.userData[key] = data;
}

export const getUserData = (key) => {
  return mpedStore.userData[key];
}


